import type { BlockViewProps } from '../../core/types';
import { RiskRegisterRenderer } from '../../directives/renderers/RiskRegisterRenderer';

export function RiskRegisterBlockView(_props: BlockViewProps) {
    return <RiskRegisterRenderer />;
}
